var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"owc-video-player-thumbnail"},[(_vm.imageData)?_c('GenericImage',{staticClass:"owc-video-player-thumbnail__image",attrs:{"component-id":_vm.thumbnailId,"imageData":_vm.imageData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }